import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthUser } from './types';

interface AuthState {
  checked: boolean;
  authenticated: boolean;
  user: AuthUser | null;
}

const initialState: AuthState = {
  checked: false,
  authenticated: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    fetchMeRequested() {},
    fetchMeSucceeded(
      state,
      action: PayloadAction<{ authenticated: boolean; user: AuthUser | null }>,
    ) {
      state.checked = true;
      state.authenticated = action.payload.authenticated;
      state.user = action.payload.user;
    },
    fetchMeFailed(state) {
      state.checked = true;
      state.authenticated = false;
      state.user = null;
    },
  },
});

export const { fetchMeRequested, fetchMeSucceeded, fetchMeFailed } = authSlice.actions;

export default authSlice.reducer;
